export default __webpack_public_path__ + "static/media/report_13.a5214275.png";